import { render } from "./CollectionsPanelDialog.vue?vue&type=template&id=7119c33b&scoped=true"
import script from "./CollectionsPanelDialog.vue?vue&type=script&lang=js"
export * from "./CollectionsPanelDialog.vue?vue&type=script&lang=js"

import "./CollectionsPanelDialog.vue?vue&type=style&index=0&id=7119c33b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7119c33b"]])

export default __exports__